import { StatusFilter } from '../../../types/general.types';

export enum PerksColumn {
  ACTIONS = 'actions',
  CHECKBOX = 'checkbox',
  INDUSTRY = 'industry',
  NUMBER_OF_CLICKS = 'number-of-clicks',
  PARTNER = 'partner',
  POC = 'poc',
  STATUS = 'status',
  TYPE = 'type',
}

export const perksColumnTranslationKey: Record<PerksColumn, string> = {
  [PerksColumn.CHECKBOX]: 'Checkbox',
  [PerksColumn.PARTNER]: 'Partner',
  [PerksColumn.INDUSTRY]: 'Industry',
  [PerksColumn.TYPE]: 'Type',
  [PerksColumn.POC]: 'Poc',
  [PerksColumn.NUMBER_OF_CLICKS]: 'Number of clicks',
  [PerksColumn.STATUS]: 'Status',
  [PerksColumn.ACTIONS]: 'Actions',
};

export enum PerksSortByColumn {
  PARTNER = 'sort-by-partner',
  STATUS = 'sort-by-status',
  TYPE = 'sort-by-type',
}

export const perksColumnSortMap: PartialRecord<PerksColumn, PerksSortByColumn> = {
  [PerksColumn.PARTNER]: PerksSortByColumn.PARTNER,
  [PerksColumn.TYPE]: PerksSortByColumn.TYPE,
};

export enum PerkStatusFilter {
  DRAFTS = 'filter-drafts',
}

export type PerkStatusFilterUnion = PerkStatusFilter | StatusFilter;

export const perksStatusFilterTranslationKey: Record<PerkStatusFilterUnion, string> = {
  [StatusFilter.ALL]: 'All',
  [StatusFilter.ACTIVE]: 'Active',
  [StatusFilter.INACTIVE]: 'Inactive',
  [PerkStatusFilter.DRAFTS]: 'Drafts',
};

export const perksStatusFilterMap = Object.keys(perksStatusFilterTranslationKey);

export const perksColumnOrderMap = Object.keys(perksColumnTranslationKey);
